const getAllBookingAccount = `getAllBookingAccount{ id, title, booking_account_nr, external_reference }`;

export default getAllBookingAccount;
